import { Routes } from "@angular/router";

import { ConditionalKeys } from "type-fest";

export const SLUGS = {
  home: "historische-unterlagen-st-gallen",
  _home: {
    cantons: "digitalisierung-kantonsarchiv",
    communes: "digitalisierung-staatsarchiv",
  },
};

export function addSlugRedirects<T, K extends ConditionalKeys<T, string> & string>(routes: Routes, slugObj: T, slugKeys: Array<K>): Routes {
  slugKeys.forEach((key) => {
    const slug = String(slugObj[key]);
    if (slug.toLowerCase() === key.toLowerCase()) return;
    routes.unshift({ path: key, redirectTo: slug });
  });
  return routes;
}
